module.exports = __webpack_public_path__ + "media/images/global/glyph-logo_May2016-824b1c9586b71519774a09960273cf37.png";